import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-welcome-dialog',
    templateUrl: './welcome-dialog.component.html',
    styleUrls: ['./welcome-dialog.component.css'],
    standalone: false
})
export class WelcomeDialogComponent {
    readonly supportEmail = 'drew.burns@cfacorp.com';

    constructor(public dialogRef: MatDialogRef<WelcomeDialogComponent>) {}

    close() {
        this.dialogRef.close();
    }
}
